import React from 'react';

type Props = {
    count:number;
    total:number;
}

const Progress = ({count, total}:Props) => (
    <div className="progress-bar" aria-label={`step ${count} of ${total}`}>
        <ul>
            {Array.from({length: total}).map((_, idx) => (
                <li key={idx} className={count >= idx+1 ? 'active' : ''} />
            ))}
        </ul>
    </div>
);

export default Progress;